module.exports = __webpack_public_path__ + "img/927bfe93c35e4041a83bb6ce11f0ab6.345a953f.png";